let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9PLvk")).then(() => parcelRequire('hlQGS'));